<template lang="pug"> 
erp-view(
  id="RolesDboTab"
  ref="RolesDboTab"
  title="Roles Dbo"
  :blank="true"
  :hide-header-title="true" hide-header-action=true
)
 
  // ───────── CONTENIDO ─────────
  template(slot="content")

    .form-container
      // ───────── SECCIÓN PRINCIPAL ─────────
      .section   
        .section-title.centered   
          span.usuario-nombre-badge
            i.fas.fa-user-tag
            |Usuario : {{ modelo.nombreCompleto || 'Sin nombre' }}

      .section 
        .section-header 
          .section-icon 🧩
          .section-title 
            | Roles del Esquema DBO      

        .section-body
          // ============ GRID DE TRES COLUMNAS ============
          .ed-grid.s-grid-1.m-grid-3.rows-gap.gap-1

            // ---- CLONADOS ----
            .s-cols-1.m-cols-1
              .card.card-dark
                .card-title
                  i.fas.fa-clone
                  |  Roles Clonados  ({{ rolesClonados.length }})
                div.tree-actions
                  a.btn-select-all(@click="seleccionarTodosClonados") 
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosClonados") 
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-tree-view(
                  ref="treeClonados"
                  :items="rolesClonadosTree"
                  data-structure="tree"
                  key-expr="id"
                  display-expr="nombre"
                  :search-enabled="true"
                  search-mode="contains"
                  show-check-boxes-mode="normal"
                  selection-mode="multiple"
                  :select-by-click="true"
                  :scrolling-enabled="true"
                  height="250"
                  @selection-changed="onSeleccionChangedClonados"
                )
                .card-actions
                  dx-button(
                    text="Aplicar a Asignados"
                    type="normal"
                    icon="fa fa-arrow-right"
                    @click="moverSeleccionadosClonadosAAsignados"
                  )

            // ---- ASIGNADOS ----
            .s-cols-1.m-cols-1
              .card.card-green
                .card-title
                  i.fas.fa-check-circle
                  |  Roles Asignados ({{ rolesAsignados.length }})
                div.tree-actions
                  a.btn-select-all(@click="seleccionarTodosAsignados") 
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosAsignados") 
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-tree-view(
                  ref="treeAsignados"
                  :items="rolesAsignadosTree"
                  data-structure="tree"
                  key-expr="id"
                  display-expr="nombre"
                  :search-enabled="true"
                  search-mode="contains"
                  show-check-boxes-mode="normal"
                  selection-mode="multiple"
                  :select-by-click="true"
                  :scrolling-enabled="true"
                  height="250"
                  @selection-changed="onSeleccionChangedAsignados"
                )
                .card-actions
                  dx-button(
                    text="Quitar Roles Seleccionados"
                    type="danger"
                    icon="fa fa-trash"
                    @click="quitarSeleccionadosDeAsignados"
                  )

            // ---- NO ASIGNADOS ----
            .s-cols-1.m-cols-1
              .card.card-red
                .card-title
                  i.fas.fa-times-circle
                  |  Roles No Asignados ({{ rolesDisponibles.length }})
                
                div.tree-actions
                  a.btn-select-all(@click="seleccionarTodosDisponibles") 
                    i.fa.fa-check-square.mr-1
                    | Marcar todos

                  a.btn-unselect-all(@click="deseleccionarTodosDisponibles") 
                    i.fa.fa-square.mr-1
                    | Quitar selección
                dx-tree-view(
                  ref="treeDisponibles"
                  :items="rolesDisponiblesTree"
                  data-structure="tree"
                  key-expr="id"
                  display-expr="nombre"
                  :search-enabled="true"
                  search-mode="contains"
                  show-check-boxes-mode="normal"
                  selection-mode="multiple"
                  :select-by-click="true"
                  :scrolling-enabled="true"
                  height="250"
                  @selection-changed="onSeleccionChangedDisponibles"
                )
                .card-actions
                  dx-button(
                    text="Asignar al Usuario"
                    type="success"
                    icon="fa fa-arrow-left"
                    @click="moverSeleccionadosDisponiblesAAsignados"
                  )

      // ───────── SECCIÓN DE PERMISOS ─────────
      .section.subtle.mt-2
        .section-header
          .section-icon ⚙️
          .section-title Opciones Habilitados por Roles DBO
        .section-body
          dx-data-grid(
            :data-source="opcionesHabilitados"  
            height="520"  
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="true"
            row-alternation-enabled
            :column-auto-width="true"
            :allow-column-resizing="true"
            :column-resizing-mode="'widget'"
            :word-wrap-enabled="true"
            :scrolling="{ mode: 'virtual' }" 
            :filter-row="{ visible: true }"
            :header-filter="{ visible: true }"  
            :grouping="{ autoExpandAll: false }"
            :group-panel="{ visible: true }"
          )
            dx-column(data-field="modulo" caption="Módulo" width="140" allow-sorting)
            dx-column(data-field="rol" caption="Rol" width="180" allow-sorting)
            dx-column(data-field="fechaCreacion" caption="Creación" data-type="datetime" format="dd/MM/yyyy" width="100" alignment="center")
            dx-column(data-field="fechaModificacion" caption="Modificación" data-type="datetime" format="dd/MM/yyyy" width="100" alignment="center")
            dx-column(data-field="opcion" caption="Opción" width="200" )
            dx-column(data-field="control" caption="Control" width="200"  )
      
      .section.subtle.mt-2
        .section-header 
        .section-body

</template>

<script>
 
import controlUsuarioResource from "@/api/ControlUsuarioResource.js";

export default {
  name: "RolesDboTab",
  props: { 
    modelo: { type: Object, required: true },
    listas: { type: Object, required: true } 
  },
  data() {
    return {
      // ===== ROLES ===== 
      rolesClonados: [],
      rolesAsignados: [],
      rolesDisponibles: [],
      opcionesHabilitados:[],

      // Árboles
      rolesClonadosTree: [],
      rolesAsignadosTree: [],
      rolesDisponiblesTree: [],

      // Selecciones
   
      seleccionadosClonados: [],
      seleccionadosAsignados: [],
      seleccionadosDisponibles: [], 
      // Permisos simulados
      permisosPorRol: {
        "Supervisor Creditos": [
          { modulo: "EVENTOS", opcion: "Aprobar crédito cliente" },
          { modulo: "EVENTOS", opcion: "Revisar historial crédito" }
        ],
        "Asesor de ventas": [
          { modulo: "VENTAS", opcion: "Crear pedido" },
          { modulo: "VENTAS", opcion: "Ver clientes" }
        ]
      }
    };
  },
  mounted() {
    console.log("RolesDboTab montado"); // eslint-disable-line   
  },

  watch: {
    // Este watch se dispara cuando el padre actualiza las listas
    listas: {
      handler(nuevasListas) {
        if (!nuevasListas) return;

        this.rolesClonados = nuevasListas.rolesDboClonados || [];
        this.rolesAsignados = nuevasListas.rolesDboAsignados || [];
        this.rolesDisponibles = nuevasListas.rolesDboDisponibles || [];
        this.opcionesHabilitados = nuevasListas.opcionesHabilitados || [];

        this.regenerarTrees();
        this.syncConPadre();
      },
      deep: true,
      immediate: true, // se ejecuta también la primera vez
    }
    
  }, 
  methods: {
      
    seleccionarTodosAsignados() {
      const tree = this.$refs.treeAsignados.instance;
      const keys = this.obtenerKeysRecursivos(this.rolesAsignadosTree);
      tree.selectAll();
      tree.option("selectedItemKeys", keys);
    },

    deseleccionarTodosAsignados() {
      this.$refs.treeAsignados.instance.unselectAll();
    },
 
    seleccionarTodosDisponibles() {
      const tree = this.$refs.treeDisponibles.instance;
      const keys = this.obtenerKeysRecursivos(this.rolesDisponiblesTree);
      tree.selectAll();
      tree.option("selectedItemKeys", keys);
    },

    deseleccionarTodosDisponibles() {
      this.$refs.treeDisponibles.instance.unselectAll();
    },

    seleccionarTodosClonados() {
      const tree = this.$refs.treeClonados.instance;
      const allKeys = this.obtenerKeysRecursivos(this.rolesClonadosTree);

      tree.selectAll(); // método nativo
      tree.option("selectedItemKeys", allKeys);
    },

    // ✔ Quitar selección total
    deseleccionarTodosClonados() {
      const tree = this.$refs.treeClonados.instance;
      tree.unselectAll(); // método nativo
    },

    // ✔ Obtiene todos los IDs del árbol (IMPORTANTE)
    obtenerKeysRecursivos(items) {
      let keys = [];
      items.forEach(i => {
        keys.push(i.id);
        if (i.items?.length) {
          keys = keys.concat(this.obtenerKeysRecursivos(i.items));
        }
      });
      return keys;
    },

    
    agruparEnTree(items, prefijo) {
      const modulos = [...new Set(items.map(r => r.modulo))];

      return modulos.map(mod => {
        const rolesDelModulo = items.filter(r => r.modulo === mod);
        return {
          id: `${prefijo}-${mod}`,
          nombre: `${mod} (${rolesDelModulo.length})`, // 🔹 agrega el número entre paréntesis
          expanded: false,
          items: rolesDelModulo.map(r => ({
            id: `${r.id}-${r.idSistema}`, // ⚡ clave compuesta única
            idRol: r.id,
            idSistema: r.idSistema,
            nombre: r.nombre,
            modulo: r.modulo
          }))
        };
      });
    },
    regenerarTrees() {
      this.rolesClonadosTree    = this.agruparEnTree(this.rolesClonados,    "mod-clonados");
      this.rolesAsignadosTree   = this.agruparEnTree(this.rolesAsignados,   "mod-asignados");
      this.rolesDisponiblesTree = this.agruparEnTree(this.rolesDisponibles, "mod-disponibles");

      this.seleccionadosClonados = [];
      this.seleccionadosAsignados = [];
      this.seleccionadosDisponibles = [];
    },
    syncConPadre() {
      this.$set(this.modelo, "rolesDboAsignados", [...this.rolesAsignados]);
    },
    AsignarRolesDbo(rolesDbo,UsuarioId) { 
      
      controlUsuarioResource
        .asignarRolesDbo(rolesDbo,UsuarioId)
        .then(() => { 
          //Object.assign(this.modelo, res.data);  
          this.$emit("roles-dbo-actualizados", this.modelo.id, this.modelo.usuarioClonarId);
          this.$msg.success("Ejecucion Terminada"); 
        })
        .catch(err => { 
          this.$msg.handleError(err, "Asinar roles DBO");
        });

    },
    RetirarRolesDbo(rolesDbo,UsuarioId) { 
      
      controlUsuarioResource
        .retirarRolesDbo(rolesDbo,UsuarioId)
        .then(() => { 
          //Object.assign(this.modelo, res.data);  
          this.$emit("roles-dbo-actualizados", this.modelo.id, this.modelo.usuarioClonarId);
          this.$msg.success("Ejecucion Terminada"); 
        })
        .catch(err => { 
          this.$msg.handleError(err, "Retirar roles DBO");
        });

    },
    // ===== SELECCIÓN =====
   // === CLONADOS ===
    onSeleccionChangedClonados(e) {
      const seleccionKeys =
        e.component._dataAdapter?.getSelectedNodesKeys?.() ||
        e.component.dataAdapter?.("selectedNodesKeys") ||
        [];

      // 🔹 Convierte cada key ("10-42") a { id: 10, idSistema: 42 }
      const seleccionTuplas = seleccionKeys.map(k => {
        const [id, idSistema] = k.split("-");
        return { id: Number(id), idSistema: Number(idSistema) };
      });

      // 🔹 Filtra los roles clonados que coinciden por id + idSistema
      this.seleccionadosClonados = this.rolesClonados.filter(r =>
        seleccionTuplas.some(sel => sel.id === r.id && sel.idSistema === r.idSistema)
      );

      console.log("✅ Objetos seleccionados (clonados):", this.seleccionadosClonados); // eslint-disable-line
    },

    // === ASIGNADOS ===
    onSeleccionChangedAsignados(e) {
      const seleccionKeys =
        e.component._dataAdapter?.getSelectedNodesKeys?.() ||
        e.component.dataAdapter?.("selectedNodesKeys") ||
        [];

          const seleccionTuplas = seleccionKeys.map(k => {
            const [id, idSistema] = k.split("-");
            return { id: Number(id), idSistema: Number(idSistema) };
          });

          this.seleccionadosAsignados = this.rolesAsignados.filter(r =>
            seleccionTuplas.some(sel => sel.id === r.id && sel.idSistema === r.idSistema)
          );

          console.log("✅ Objetos seleccionados (asignados):", this.seleccionadosAsignados); // eslint-disable-line
        },
    // === DISPONIBLES ===
    onSeleccionChangedDisponibles(e) {
      // obtiene las claves seleccionadas ["10-42", "50-42", ...]
      const seleccionKeys =
        e.component._dataAdapter?.getSelectedNodesKeys?.() ||
        e.component.dataAdapter?.("selectedNodesKeys") ||
        [];

      // crea un conjunto de combinaciones id+idSistema
      const seleccionTuplas = seleccionKeys.map(k => {
        const [id, idSistema] = k.split("-");
        return { id: Number(id), idSistema: Number(idSistema) };
      });

      // filtra la lista base
      this.seleccionadosDisponibles = this.rolesDisponibles.filter(r =>
        seleccionTuplas.some(sel => sel.id === r.id && sel.idSistema === r.idSistema)
      );

      console.log("✅ Objetos seleccionados (disponibles):", this.seleccionadosDisponibles); // eslint-disable-line
    },
    // ===== ACCIONES =====
    moverSeleccionadosClonadosAAsignados() {

     if (!this.seleccionadosClonados.length) {
          this.$msg.error("Seleccione al menos un rol Clonado para aplicar."); // opcional
          return;
        }  

        this.AsignarRolesDbo(this.seleccionadosClonados,this.modelo.id)
        this.regenerarTrees(); 
 
    },
    quitarSeleccionadosDeAsignados() {

       if (!this.seleccionadosAsignados.length) {
          this.$msg.error("Seleccione al menos un rol Asignado para retirarlo."); // opcional
          return;
        }  

        this.RetirarRolesDbo(this.seleccionadosAsignados,this.modelo.id)
        this.regenerarTrees(); 
 

    },
    moverSeleccionadosDisponiblesAAsignados() { 

      if (!this.seleccionadosDisponibles.length) {
            this.$msg.error("Seleccione al menos un rol Por Asignar, para aplicar."); // opcional
            return;
          }  

        this.AsignarRolesDbo(this.seleccionadosDisponibles,this.modelo.id)
        this.regenerarTrees(); 
 
    }
  }
};
</script>

<style scoped>
 
.section-title.centered {
  display: flex;
  justify-content: center;       /* 🔹 centra horizontalmente */
  align-items: center;
  text-align: center;
  gap: 8px;
  margin-bottom: 10px;
}

.form-container {
  background: #f8fafc;
  padding: 10px 12px;
  border-radius: 10px;
  max-width: 960px;
  min-height: 100%;         /* ✅ evita que el grid se desborde */
  max-height: 700px;    
  margin: 0 auto;
  margin-left: 0 !important; 
  overflow-y: visible !important; /* para que no bloquee el scroll del popup */
}

.text-muted { color: #64748b; font-size: 11.5px; }

/* ==== SECCIONES ==== */
.section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  margin-bottom: 5px;
  padding: 10px 15px;
   
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.section:hover { transform: translateY(-1.5px); box-shadow: 0 3px 8px rgba(0,0,0,0.08); }
.section.subtle {
  background: #f4faff;
  border-left: 3px solid #4ea1ff;
  overflow: hidden;          /* ✅ evita que el grid se desborde */
  max-height: 700px;         /* ✅ ajusta según tu popup */
}
.usuario-nombre-badge {
  display: inline-flex;
  align-items: center !important;
  gap: 6px;
  font-weight: 800;
  background: #e0f2fe;
  color: #0369a1;
  border: 1px solid #7dd3fc;
  padding: 2px 14px;
  border-radius: 20px;
  margin-left: 8px;
  font-size: 18px;
}
.usuario-nombre-badge i {
  color:  #4acb1f;
}

.section-header { display: flex; align-items: center; margin-bottom: 6px; }
.section-icon { font-size: 18px; margin-right: 6px; }
.section-title { font-weight: 500; font-size: 14px; color: #005b99; }

/* ==== TARJETAS ==== */
.card { border: 1px solid #e2e8f0; border-radius: 8px; background: #fff; padding: 10px; min-height: 220px; }
.card-title { font-weight: 600; margin-bottom: 6px; display: flex; align-items: center; gap: 8px; font-size: 15px;  }
.card-actions { display: flex; gap: 6px; margin-top: 10px; flex-wrap: wrap; justify-content: center; }
.card-dark { border-color: #111827; }
.card-green { border-color: #10b981; }
.card-red { border-color: #ef4444; }

/* ==== SCROLL CORRECTO ==== */
  

.mt-2 { margin-top: 8px; }

.tree-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 6px;
}

.tree-actions a {
  cursor: pointer;
  font-size: 0.85rem;
  color: #2563eb;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.tree-actions a:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

</style>
